import { Grid, makeStyles } from '@material-ui/core';
import * as yup from 'yup';
import { useTranslation } from 'react-i18next';
import { Form, Formik } from 'formik';
import React from 'react';
import { FormikTextField } from '../../../components/input/FormikTextField';
import { LoadingButton } from '../../../components/input/button/LoadingButton';

const useStyles = makeStyles((theme) => ({
  form: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1)
  }
}));

const validationSchema = yup.object().shape({
  password: yup
    .string()
    .required('required')
    .min(10, 'Password must have at least 10 characters'),
  passwordConfirmation: yup
    .string()
    .oneOf([yup.ref('password'), null], 'Passwords must match')
});

const initialState = {
  password: '',
  passwordConfirmation: ''
};

interface ApplyPasswordResetFormProps {
  onSubmit: (password: string) => Promise<void>;
}

export function ApplyPasswordResetForm({
  onSubmit
}: ApplyPasswordResetFormProps) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Formik
      initialValues={initialState}
      validationSchema={validationSchema}
      onSubmit={(values) => onSubmit(values.password)}
    >
      {({ submitForm }) => (
        <Form className={classes.form}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <FormikTextField
                type="password"
                name="password"
                variant="outlined"
                label={t('password')}
              />
            </Grid>
            <Grid item xs={12}>
              <FormikTextField
                type="password"
                name="passwordConfirmation"
                variant="outlined"
                label={t('confirm password')}
              />
            </Grid>
            <Grid item xs={12}>
              <LoadingButton
                fullWidth
                // loading={authState === 'login-pending'}
                onClick={submitForm}
              >
                {t('Update Password')}
              </LoadingButton>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
}
